module.exports = __webpack_public_path__ + "static/media/silent.2b5bb705.mp3";